<hgroup class="register-user-form__title">
  <h2 class="title__text ci-heading-h1-bold">{{ 'Planifica tu viaje' | translate }}</h2>
  @if (cityLocation()) {
    <span class="title__text ci-heading-h1-bold"> {{ 'a' | translate }}</span>
    <h1 class="title__client-name ci-heading-h1-bold">{{ cityLocation() }}</h1>
  }
</hgroup>

<div class="register-user-form__container">
  <div class="register-user-form__column">
    <app-date-field
      [form]="form()"
      formControlNameStartDate="startDate"
      formControlNameEndDate="endDate"
    />
    
    <hr class="register-user-form__divider"/>
    
    <div class="register-user-form__stay-info">
      <h3 class="stay-info__title ci-heading-h3-s-bold">
        {{ 'Estancia' | translate }}
      </h3>
      
      <app-time-fields
        [form]="form()"
        formControlNameStartTime="startTime"
        formControlNameEndTime="endTime"
      />
      
      <app-movility-field 
        [form]="form()" 
        formControlName="movilityType"
      />

      <app-location-field
        [form]="form()" 
        formControlName="startLocationAddress"
      />  
    </div>
  </div>           

  <div class="register-user-form__column">
    <app-trip-types-field
      [form]="form()" 
      formControlName="tripType"
    />
    
    <hr class="register-user-form__divider"/>

    <app-interests-field
      [form]="form()" 
      formControlName="interestIdList"
    />
  </div>
            
  <div class="register-user-form__column">
    <app-transport-means-field
      [form]="form()" 
      formControlName="transportMeans"
    />

    <hr class="register-user-form__divider"/>

    <app-max-distance-field 
      [form]="form()" 
      formControlName="maxDistanceWalking"
    />
    
    <ci-fab-button 
      class="register-user-form__submit-button"
      class-name="ci-btn-primary-filled" 
      type="submit"
      [disabled]="!form().valid"
      (click)="handleSubmit()"
      [matTooltip]="tooltipText()"
      [matTooltipPosition]="'above'"
    >
      {{ 'Continuar' | translate }}
    </ci-fab-button>
  </div>
</div>
